import { lazy, Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { BASE_ROUTE, RouteParams } from "../../../constants";
import { Navigation } from "../../../pages/insight/navigation/Navigation";
import LoginComplete from "../../../pages/insight/users/loginComplete/LoginComplete_view";
import { NavigateToCurrentOrg } from "../../../routes/Redirects";
import { CHANGE_BASE_ROUTE } from "../../change/routes/pages";
import { BASE_GRID_ROUTE } from "../../grids/routes/pages";
import { BASE_PROCESSES_ROUTE } from "../../processes/routes/pages";
import { BASE_TRAINING_ROUTE } from "../../training/routes/pages";
import { DashboardRoutes } from "./dashboardRoutes";
import {
  BASE_DASHBOARD_ROUTE,
  BASE_PROGRAMMES_ROUTE,
  BASE_PROJECT_ROUTE,
  BASE_USER_ROUTE,
  ShellPages
} from "./shellPages";
import { BASE_SURVEY_ROUTE } from "../../survey/routes/pages";
import { FullGridPage } from "../../../components/hoc/FullGridPage";
import { ModalContextProvider } from "../../../core/modalZ/context/ModalContext";
import { PositionedSpinner } from "../../../components/ui/PositionedSpinner";

const GridRoutes = lazy(() => import("../../grids/routes/routes"));
const ChangeRoutes = lazy(() => import("../../change/routes/routes"));
const TrainingRoutes = lazy(() => import("../../training/routes/routes"));
const ProcessesRoutes = lazy(() => import("../../processes/routes/routes"));
const OrganisationRoutes = lazy(() => import("./organisationRoutes"));
const ProgrammeRoutes = lazy(() => import("./programmeRoutes"));
const ProjectRoutes = lazy(() => import("./projectRoutes"));
const UserRoutes = lazy(() => import("./userRoutes"));
const SurveyRoutes = lazy(() => import("../../survey/routes/routes"));

const ContextRoute: React.FC = () => {
  return (
    <ModalContextProvider>
      <Outlet />
    </ModalContextProvider>
  );
};
export const ShellRoutes: React.FC<ReactProps> = () => {
  return (
    <Routes>
      <Route element={<ContextRoute />}>
        <Route path={ShellPages.users.auth.loginComplete.path} element={<LoginComplete />} />
        <Route path="/organisations/:organisationId" element={<NavigateToCurrentOrg />} />
        <Route path="/" element={<NavigateToCurrentOrg />} />
        <Route path="/takemeto/current-organisation" element={<NavigateToCurrentOrg />} />
        <Route
          path={`${BASE_GRID_ROUTE}/projects/${RouteParams.projectId}/*`}
          element={
            <Suspense fallback={<PositionedSpinner />}>
              <FullGridPage>
                <GridRoutes />
              </FullGridPage>
            </Suspense>
          }
        />

        <Route path="/" element={<Navigation />}>
          <Route
            path={`${CHANGE_BASE_ROUTE}/projects/${RouteParams.projectId}`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ChangeRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${CHANGE_BASE_ROUTE}/projects/${RouteParams.projectId}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ChangeRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_TRAINING_ROUTE}/projects/${RouteParams.projectId}`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <TrainingRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_TRAINING_ROUTE}/projects/${RouteParams.projectId}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <TrainingRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_PROCESSES_ROUTE}/projects/${RouteParams.projectId}`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ProcessesRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_PROCESSES_ROUTE}/projects/${RouteParams.projectId}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ProcessesRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_SURVEY_ROUTE}/projects/${RouteParams.projectId}`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <SurveyRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_SURVEY_ROUTE}/projects/${RouteParams.projectId}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <SurveyRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_PROGRAMMES_ROUTE}/${RouteParams.programmeId}`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ProgrammeRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_PROGRAMMES_ROUTE}/${RouteParams.programmeId}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ProgrammeRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_PROJECT_ROUTE}/${RouteParams.projectId}`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ProjectRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_PROJECT_ROUTE}/${RouteParams.projectId}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <ProjectRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_DASHBOARD_ROUTE}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <DashboardRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_ROUTE}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <OrganisationRoutes />
              </Suspense>
            }
          />
          <Route
            path={`${BASE_USER_ROUTE}/*`}
            element={
              <Suspense fallback={<PositionedSpinner />}>
                <UserRoutes />
              </Suspense>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};
